module.exports = __webpack_public_path__ + "assets/img/uesrIcon4.50cd0c55.png";